import React from 'react';
import { Pagination } from 'ds/components/pagination';
import { PER_PAGE } from 'store/sagas/routing/handlers/developersCitySearchPage';
import { State } from 'store/state';
import { State as RouteState } from 'config/routes';
import { connect } from 'react-redux';
import { routeSelector } from 'store/state/selectors/router';
import { createPageItemRenderer, createPageSwitcherRenderer } from 'ds/components/pagination/pagination-renderers';
import { noop } from 'lodash';

interface PaginationProps {
  page: number;
  totalCount: number;
  route: RouteState;
}

const DevelopersPagination: React.FC<PaginationProps> = (props) => {
  const { page, route, totalCount } = props;

  if (!totalCount) return null;

  const totalPages = Math.ceil(totalCount / PER_PAGE);

  if (totalPages === 1) return null;

  return (
    <Pagination
      totalPages={totalPages}
      onSetActivePage={noop}
      activePage={page || 1}
      paginationType="pages"
      renderPageItem={createPageItemRenderer(route)}
      renderPageSwitcher={createPageSwitcherRenderer(route)}
    />
  );
};

const mapStateToProps = (state: State) => ({
  route: routeSelector(state),
});


export default connect(mapStateToProps)(DevelopersPagination);
